<template>
  <div id="settings">
    <h2>Paramètres de l'application</h2>
    <hr />
    <h5>Synchronisation</h5>
    <label>
      Heure de synchronisation&nbsp;
      <div class="mytooltip">
        <font-awesome-icon :icon="'question'" />
        <span
          class="mytooltiptext"
        >Les employés se synchronisent avec WK tous les jours à cette heure-ci</span>
      </div>&nbsp;
    </label>
    <date-picker v-model="syncTime" type="time"></date-picker>
    <button class="btn btn-primary btn-sm" @click="setSyncTime">Définir</button>
    <br />
    <button type="button" class="mt-2 btn btn-secondary btn-sm" @click="synchroniser">
      <font-awesome-icon :icon="'sync'" />&nbsp;Forcer une synchronisation des employés
    </button>
    <hr />
    <h5>Comptabilité des heures</h5>
    <h6>
      Périodes salariales :
      <div class="mytooltip">
        <font-awesome-icon :icon="'question'" />
        <span
          class="mytooltiptext"
        >Ces dates définissent les périodes salariales, ne pas faire spécialement attention à l'année choisie dans le calandrier, il faut simplement garder la même. Pas besoin de le redéfinir chaque année, seuls les jours et les mois comptent</span>
      </div>
    </h6>
    <table>
      <tr>
        <td>
          <label>Janvier :&nbsp;</label>
        </td>
        <td>
          <date-picker v-model="periodes[0]" range type="date" format="DD/MM" />
        </td>
      </tr>
      <tr>
        <td>
          <label>Février :&nbsp;</label>
        </td>
        <td>
          <date-picker v-model="periodes[1]" range type="date" format="DD/MM" />
        </td>
      </tr>
      <tr>
        <td>
          <label>Mars :&nbsp;</label>
        </td>
        <td>
          <date-picker v-model="periodes[2]" range type="date" format="DD/MM" />
        </td>
      </tr>
      <tr>
        <td>
          <label>Avril :&nbsp;</label>
        </td>
        <td>
          <date-picker v-model="periodes[3]" range type="date" format="DD/MM" />
        </td>
      </tr>
      <tr>
        <td>
          <label>Mai :&nbsp;</label>
        </td>
        <td>
          <date-picker v-model="periodes[4]" range type="date" format="DD/MM" />
        </td>
      </tr>
      <tr>
        <td>
          <label>Juin :&nbsp;</label>
        </td>
        <td>
          <date-picker v-model="periodes[5]" range type="date" format="DD/MM" />
        </td>
      </tr>
      <tr>
        <td>
          <label>Juillet :&nbsp;</label>
        </td>
        <td>
          <date-picker v-model="periodes[6]" range type="date" format="DD/MM" />
        </td>
      </tr>
      <tr>
        <td>
          <label>Août :&nbsp;</label>
        </td>
        <td>
          <date-picker v-model="periodes[7]" range type="date" format="DD/MM" />
        </td>
      </tr>
      <tr>
        <td>
          <label>Septembre :&nbsp;</label>
        </td>
        <td>
          <date-picker v-model="periodes[8]" range type="date" format="DD/MM" />
        </td>
      </tr>
      <tr>
        <td>
          <label>Octobre :&nbsp;</label>
        </td>
        <td>
          <date-picker v-model="periodes[9]" range type="date" format="DD/MM" />
        </td>
      </tr>
      <tr>
        <td>
          <label>Novembre :&nbsp;</label>
        </td>
        <td>
          <date-picker v-model="periodes[10]" range type="date" format="DD/MM" />
        </td>
      </tr>
      <tr>
        <td>
          <label>Décembre :&nbsp;</label>
        </td>
        <td>
          <date-picker v-model="periodes[11]" range type="date" format="DD/MM" />
        </td>
      </tr>
    </table>
    <button @click="setPeriodes" class="btn btn-success btn-sm">Enregister</button>
    <hr />
    <h5>Console</h5>
    <div class="form-group">
      <div class="custom-control custom-checkbox">
        <input
          v-model="console"
          @click="toggleConsole"
          type="checkbox"
          class="custom-control-input"
          id="customCheck1"
          checked
        />
        <label class="custom-control-label" for="customCheck1">Afficher la console</label>
      </div>
    </div>
    <hr />
    <h5>Données</h5>
    <div class="card border-danger mb-3" style="max-width: 20rem;">
      <div class="custom-control custom-switch ml-3">
        <input v-model="del" type="checkbox" class="custom-control-input" id="del" />
        <label class="custom-control-label" for="del">Je souhaite supprimer des données</label>
      </div>
      <div class="card-body">
        <button
          :disabled="!del"
          @click="deleteAllHoraires"
          class="btn btn-sm btn-danger"
        >Supprimer tous les horaires et remplacements</button>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import Swal from "sweetalert2";
import DatePicker from "vue2-datepicker";
import moment from "moment";

const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000
});

export default {
  data() {
    return {
      console: false,
      del: false,
      syncTime: new Date(),
      periodes: []
    };
  },
  components: {
    DatePicker
  },
  async created() {
    await this.load();
    this.console = this.$store.state.console;
  },
  methods: {
    async load() {
      this.syncTime = new Date(
        "1970-01-01 " + (await api.getSyncTime()).data.syncTime
      );
      this.periodes = (await api.getPeriodes()).data.periodes;
      for (let periode of this.periodes) {
        for (let i = 0; i < 2; i++) {
          periode[i] = new Date(periode[i]);
        }
      }
    },
    async synchroniser() {
      Swal.fire({
        title: "Synchronisation des employés...",
        html:
          "Cette opération peut prendre un certain temps. Merci de patienter",
        allowOutsideClick: false,
        onBeforeOpen: () => {
          Swal.showLoading();
        }
      });
      let result = await api.synchroniserEmployes();
      Swal.close();

      if (result.code == 200) {
        let warnings = result.data.errors.filter(error => {
          return error.type == 1;
        });
        let errors = result.data.errors.filter(error => {
          return error.type == 2;
        });
        let html_errors = "";
        for (let error of result.data.errors) {
          html_errors += `<span color="${error.type == 2 ? "red" : "orange"}">${
            error.message
          }</span><br>`;
        }
        Swal.fire({
          title:
            result.code == 200
              ? "Synchronisation terminée."
              : "Echec de la synchronisation.",
          type: result.code == 200 ? "success" : "error",
          text: `L'opération s'est terminée avec ${
            warnings.length
          } warning(s) et ${errors.length} erreur(s).${
            warnings.length + errors.length > 0
              ? "Pour plus d'informations, consultez la console ou les logs de l'application."
              : ""
          }`
        });
      } else {
        Swal.fire({
          type: "error",
          text: result.message
        });
      }
    },
    toggleConsole() {
      this.$store.commit("setConsole", !this.console);
      this.$cookies.set("console", !this.console);
    },
    async deleteAllHoraires() {
      await Swal.fire({
        title: `Attention`,
        text: `Cette action est irréversible et supprimera TOUS les horaires de la base de données. Voulez-vous continuer?`,
        type: "error",
        showCancelButton: true,
        confirmButtonColor: "red",
        cancelButtonColor: "#00bf30",
        confirmButtonText: "Supprimer",
        cancelButtonText: "Annuler"
      }).then(async result => {
        if (result.value) {
          this.$store.commit("setLoading", true);
          let response = await api.deleteAllHoraire(true);
          this.$store.commit("setLoading", false);
          Toast.fire({
            type: response.code === 200 ? "success" : "error",
            text: response.message
          });
        }
      });
    },
    async setSyncTime() {
      let response = await api.setSyncTime(
        moment(this.syncTime).format("HH:mm:ss")
      );
      Toast.fire({
        type: response.code === 200 ? "success" : "error",
        text: response.message
      });
      this.load();
    },
    async setPeriodes() {
      let response = await api.setPeriodes(this.periodes);
      Toast.fire({
        type: response.code === 200 ? "success" : "error",
        text: response.message
      });
      this.load();
    }
  }
};
</script>